<template>
  <div>
    <v-row align="end">
      <v-col cols="4" md="2" class="d-flex align-end">
        <v-select
          v-model="filtros.agrupacion"
          :items="tiposAgrupacion"
          item-value="value"
          item-text="text"
          label="Tipo de Agrupación"
          :disabled="loadingReporte"
          class="mb-0"
          hide-details
          @change="onTipoAgrupacionChange"
        />
      </v-col>

      <v-col v-if="filtros.agrupacion !== 2" cols="4" md="2" class="d-flex align-end">
        <datePicker
          v-model="filtros.Desde"
          format="YYYY-MM-DD"
          formatted="YYYY-MM-DD"
          maxToday
          label="Desde (Obligatorio)"
          noHeader
          overlay
          :disabled="loadingReporte"
        />
      </v-col>

      <v-col v-if="filtros.agrupacion !== 2" cols="4" md="2" class="d-flex align-end">
        <datePicker
          v-model="filtros.Hasta"
          format="YYYY-MM-DD"
          formatted="YYYY-MM-DD"
          label="Hasta (Obligatorio)"
          noHeader
          overlay
          maxToday
          :disabled="loadingReporte"
        />
      </v-col>

      <v-col v-if="filtros.agrupacion === 2" cols="4" md="2" class="d-flex align-end">
        <week-picker-calendar
          v-model="semanas"
          class="productividad-week-picker"
          @apply="onAplicar"
        />
      </v-col>

      <v-col cols="4" md="2" class="d-flex align-end">
        <v-autocomplete
          v-model="filtros.Areas"
          :items="areas"
          item-text="nombre"
          item-value="idArea"
          multiple
          chips
          clearable
          label="Área"
          :loading="loadingAreas"
          :disabled="loadingReporte"
          class="mb-0"
          hide-details
        >
          <template v-slot:selection="{ index }">
            <v-chip v-if="index === 0" small>
              {{ filtros.Areas.length }} áreas
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="4" md="2" class="d-flex align-end">
        <v-autocomplete
          v-model="filtros.Maquinas"
          :items="maquinas"
          :item-text="nombreMaquina"
          item-value="idMaquinaIns"
          multiple
          chips
          clearable
          label="Línea"
          :loading="loadingMaquinas"
          :disabled="loadingReporte"
          class="mb-0"
          hide-details
        >
          <template v-slot:selection="{ index }">
            <v-chip v-if="index === 0" small>
              {{ filtros.Maquinas.length }} máquinas
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="4" md="2" class="d-flex align-end">
        <v-autocomplete
          v-model="filtros.Turnos"
          :items="turnos"
          item-text="nombre"
          item-value="idTurno"
          multiple
          chips
          clearable
          label="Turno"
          :loading="loadingTurnos"
          :disabled="loadingReporte"
          class="mb-0"
          hide-details
        >
          <template v-slot:selection="{ index }">
            <v-chip v-if="index === 0" small>
              {{ filtros.Turnos.length }} turnos
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="4" md="2" class="d-flex align-end">
        <v-autocomplete
          v-model="filtros.Operadores"
          :items="operadores"
          :item-text="nombrePersona"
          item-value="idPersona"
          multiple
          chips
          clearable
          label="Operador"
          :loading="loadingOperadores"
          :disabled="loadingReporte"
          class="mb-0"
          hide-details
        >
          <template v-slot:selection="{ index }">
            <v-chip v-if="index === 0" small>
              {{ filtros.Operadores.length }} personas
            </v-chip>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <div class="d-flex align-center">
      <v-spacer />
      <v-btn color="primary" :loading="loadingReporte" :disabled="!filtrosValidos" @click="consultarReporte">
        Consultar
      </v-btn>
      <v-btn
        color="success"
        class="ml-2"
        :loading="loadingExcel"
        :disabled="loadingReporte || loadingExcel || !filtrosValidos"
        @click="descargarExcel"
      >
        Descargar Excel
      </v-btn>
    </div>

    <LoaderData :loading="loadingReporte" :response="tablaProductividad" :error="errorReporte">
      <section class="productividad-kpi-grid">
        <article
          v-for="card in kpiProductividad"
          :key="card.key"
          class="productividad-kpi-card"
          :class="`productividad-kpi-card--${card.tone}`"
        >
          <div class="productividad-kpi-top">
            <div class="productividad-kpi-icon-pack" :class="`productividad-kpi-icon-pack--${card.tone}`">
              <v-icon class="productividad-kpi-icon">{{ card.icon }}</v-icon>
            </div>
            <p class="productividad-kpi-title">{{ card.title }}</p>
          </div>
          <p v-if="card.value" class="productividad-kpi-value">{{ card.value }}</p>
          <p v-if="card.caption" class="productividad-kpi-caption">{{ card.caption }}</p>
        </article>
      </section>

      <v-data-table
        :headers="headersProductividadFinal"
        :items="tablaProductividad"
        :expanded.sync="filasExpandidas"
        :item-class="claseFilaProductividad"
        item-key="_productividadKey"
        class="mt-4"
        dense
        @click:row="onClickFilaProductividad"
      >
        <template v-slot:top>
          <div class="text-right">
            <v-btn text color="primary" class="ml-auto" @click="show_SeleccionHeaders">
              <v-icon small>mdi-filter-outline</v-icon>
              Mostrar / Ocultar Columnas
            </v-btn>
          </div>
        </template>
        <template v-slot:[`header.tiempoTrabajadoSegundos`]>
          <span class="productividad-tiempo-header">
            <span>Tiempo Trabajado</span>
            <span>(HH:MM:SS)</span>
          </span>
        </template>
        <template v-slot:[`item.area`]="{ item }">
          {{ item.area || item.Area || item.nombreArea || item.NombreArea || '' }}
        </template>
        <template v-slot:[`item.operadores`]="{ item }">
          {{ operadoresEsperadosReales(item) }}
        </template>
        <template v-slot:[`item.turno`]="{ item }">
          <span class="productividad-turno-cell">{{ formatearTurno(item.turno || item.Turno || '') }}</span>
        </template>
        <template v-slot:[`item.disponibilidad`]="{ item }">
          {{ formatearPorcentaje(valorPorCampos(item, ['disponibilidad', 'Disponibilidad'])) }}
        </template>
        <template v-slot:[`item.productividad`]="{ item }">
          {{ formatearPorcentaje(valorPorCampos(item, ['productividad', 'Productividad'])) }}
        </template>
        <template v-slot:[`item.calidad`]="{ item }">
          {{ formatearPorcentaje(valorPorCampos(item, ['calidad', 'Calidad'])) }}
        </template>
        <template v-slot:[`item.ope`]="{ item }">
          {{ formatearPorcentaje(valorPorCampos(item, ['ope', 'Ope', 'OPE'])) }}
        </template>
        <template v-slot:[`item.tiempoTrabajadoSegundos`]="{ item }">
          {{ formatearSegundosAHoras(valorTiempoTrabajadoReal(item)) }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-0 productividad-detalle-cell">
            <v-data-table
              :headers="headersProductividadFinal"
              :items="obtenerTurnosFila(item)"
              class="productividad-detalle-table"
              dense
              hide-default-footer
              disable-pagination
            >
              <template v-slot:[`header.tiempoTrabajadoSegundos`]>
                <span class="productividad-tiempo-header">
                  <span>Tiempo Trabajado</span>
                  <span>(HH:MM:SS)</span>
                </span>
              </template>
              <template v-slot:[`item.area`]="{ item: detalle }">
                {{ detalle.area || detalle.Area || detalle.nombreArea || detalle.NombreArea || '' }}
              </template>
              <template v-slot:[`item.operadores`]="{ item: detalle }">
                {{ operadoresEsperadosReales(detalle) }}
              </template>
              <template v-slot:[`item.turno`]="{ item: detalle }">
                <span class="productividad-turno-cell">
                  {{ formatearTurno(detalle.turno || detalle.Turno || detalle.nombreTurno || detalle.NombreTurno || '') }}
                </span>
              </template>
              <template v-slot:[`item.disponibilidad`]="{ item: detalle }">
                {{ formatearPorcentaje(valorPorCampos(detalle, ['disponibilidad', 'Disponibilidad'])) }}
              </template>
              <template v-slot:[`item.productividad`]="{ item: detalle }">
                {{ formatearPorcentaje(valorPorCampos(detalle, ['productividad', 'Productividad'])) }}
              </template>
              <template v-slot:[`item.calidad`]="{ item: detalle }">
                {{ formatearPorcentaje(valorPorCampos(detalle, ['calidad', 'Calidad'])) }}
              </template>
              <template v-slot:[`item.ope`]="{ item: detalle }">
                {{ formatearPorcentaje(valorPorCampos(detalle, ['ope', 'Ope', 'OPE'])) }}
              </template>
              <template v-slot:[`item.tiempoTrabajadoSegundos`]="{ item: detalle }">
                {{ formatearSegundosAHoras(valorTiempoTrabajadoReal(detalle)) }}
              </template>
            </v-data-table>
          </td>
        </template>
      </v-data-table>
      <SeleccionHeadersVue
        ref="seleccionHeaders"
        v-model="visibleHeaders"
        :headers="headersProductividad"
        path="reporte_productividad_personal"
      />
    </LoaderData>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import LoaderData from '../../LoaderData.vue';
import WeekPickerCalendar from '../../WeekPickerCalendar.vue';
import SeleccionHeadersVue from '@/components/SeleccionHeaders.vue';

export default {
  components: {
    LoaderData,
    WeekPickerCalendar,
    SeleccionHeadersVue,
  },
  data() {
    return {
      headersProductividad: [
        { text: 'Periodo', value: 'periodo', align: "center", sortable: false },
        { text: 'ODT', value: 'clave', align: "center", sortable: false },
        { text: 'Línea', value: 'maquina', align: "center", sortable: false },
        { text: 'Turno', value: 'turno', align: "center", sortable: false, width: 120, class: 'productividad-turno-header' },
        { text: 'Ops. Esp./Real', value: 'operadores', align: "center", sortable: false, width: 120 },
        { text: 'Área', value: 'area', align: "center", sortable: false },
        { text: 'Planeado ODT', value: 'cantidadPlaneadaOdt', align: "center", sortable: false },
        { text: 'Piezas Esperadas', value: 'piezasEsperadasTiempoTrabajado', align: "center", sortable: false },
        { text: 'OK', value: 'cantidadOk', align: "center", sortable: false },
        { text: 'Scrap', value: 'cantidadScrap', align: "center", sortable: false },
        { text: 'Total', value: 'cantidadTotal', align: "center", sortable: false },
        { text: 'TC Operador', value: 'tcOperadorSegundos', align: "center", sortable: false },
        { text: 'Tiempo Trabajado (HH:MM:SS)', value: 'tiempoTrabajadoSegundos', align: "center", sortable: false },
        { text: 'Disponibilidad', value: 'disponibilidad', align: "center", sortable: false },
        { text: 'Productividad', value: 'productividad', align: "center", sortable: false },
        { text: 'Calidad', value: 'calidad', align: "center", sortable: false },
        { text: 'OPE', value: 'ope', align: "center", sortable: false },
      ],
      tiposAgrupacion: [
        { text: 'Días', value: 1 },
        { text: 'Semanas', value: 2 },
        { text: 'Mes', value: 3 },
      ],
      tablaProductividad: [],
      resumenProductividad: {},
      semanas: [],
      maquinas: [],
      areas: [],
      turnos: [],
      operadores: [],
      visibleHeaders: [],
      filasExpandidas: [],
      filtros: {
        agrupacion: 1,
        Desde: null,
        Hasta: null,
        semanasSeleccionadas: [],
        Maquinas: [],
        Areas: [],
        Turnos: [],
        Operadores: [],
      },
      loadingReporte: false,
      loadingMaquinas: false,
      loadingAreas: false,
      loadingTurnos: false,
      loadingOperadores: false,
      loadingExcel: false,
      errorReporte: false,
      errores: [],
    };
  },
  computed: {
    headersProductividadFinal() {
      const values = this.visibleHeaders.length
        ? this.normalizarHeadersVisibles(this.visibleHeaders.map(header => header.value))
        : this.headersProductividad.map(header => header.value);

      return this.headersProductividad.filter(header => values.includes(header.value)).map(header => {
        if (header.value !== 'periodo') return header;

        const textos = {
          1: 'Día',
          2: 'Semana',
          3: 'Mes',
        };

        return {
          ...header,
          text: textos[this.filtros.agrupacion] || 'Día',
        };
      });
    },
    kpiProductividad() {
      return [
        {
          key: 'promedio-general',
          title: 'OPE Global',
          value: this.promedioOpe,
          caption: `${this.tablaProductividad.length} registros`,
          icon: 'mdi-chart-line',
          tone: 'blue',
        },
        {
          key: 'disponibilidad-general',
          title: 'Disponibilidad Global',
          value: this.promedioDisponibilidad,
          caption: 'Promedio del periodo',
          icon: 'mdi-clock-check-outline',
          tone: 'green',
        },
        {
          key: 'productividad-general',
          title: 'Productividad Global',
          value: this.promedioProductividad,
          caption: 'Promedio del periodo',
          icon: 'mdi-factory',
          tone: 'amber',
        },
        {
          key: 'calidad-general',
          title: 'Calidad Global',
          value: this.promedioCalidad,
          caption: 'Promedio del periodo',
          icon: 'mdi-check-decagram-outline',
          tone: 'green',
        },
      ];
    },
    promedioOpe() {
      return this.formatearPorcentaje(this.valorPorCampos(this.resumenProductividad, ['opeGlobal', 'OpeGlobal', 'OPEGlobal']));
    },
    promedioDisponibilidad() {
      return this.formatearPorcentaje(this.valorPorCampos(this.resumenProductividad, ['disponibilidadGlobal', 'DisponibilidadGlobal']));
    },
    promedioProductividad() {
      return this.formatearPorcentaje(this.valorPorCampos(this.resumenProductividad, ['productividadGlobal', 'ProductividadGlobal']));
    },
    promedioCalidad() {
      return this.formatearPorcentaje(this.valorPorCampos(this.resumenProductividad, ['calidadGlobal', 'CalidadGlobal']));
    },
    filtrosValidos() {
      const desde = this.parseFechaFiltro(this.filtros.Desde);
      const hasta = this.parseFechaFiltro(this.filtros.Hasta);

      const fechasValidas = this.filtros.agrupacion === 2
        ? this.filtros.semanasSeleccionadas.length > 0
        : desde.isValid() &&
          hasta.isValid() &&
          desde.isSameOrBefore(hasta);

      return (
        fechasValidas &&
        [1, 2, 3].includes(this.filtros.agrupacion)
      );
    },
  },
  mounted() {
    this.getOpeTiempoReal();
    this.getMaquinas();
    this.getAreas();
    this.getTurnos();
    this.getOperadores();
  },
  methods: {
    show_SeleccionHeaders() {
      this.$refs.seleccionHeaders.show_dialog();
    },
    puedeDesglosarFila(item) {
      return Number(this.filtros.agrupacion) === 1 && this.obtenerTurnosCrudos(item).length > 0;
    },
    normalizarHeadersVisibles(values) {
      const headers = values.filter(value => !['operadoresEsperados', 'operadoresReales'].includes(value));
      const teniaOperadores = values.some(value => ['operadores', 'operadoresEsperados', 'operadoresReales'].includes(value));

      return teniaOperadores && !headers.includes('operadores')
        ? [...headers, 'operadores']
        : headers;
    },
    operadoresEsperadosReales(item) {
      const esperados = this.valorPorCampos(item, ['operadoresEsperados', 'OperadoresEsperados']);
      const reales = this.valorPorCampos(item, ['operadoresReales', 'OperadoresReales']);

      if (esperados === null && reales === null) return '';
      return `${esperados ?? '-'} / ${reales ?? '-'}`;
    },
    formatearTurno(turno) {
      return String(turno || '')
        .replace(/\s*\|\s*/g, ' | ')
        .replace(/\bTURNO\b/gi, 'T.')
        .replace(/\s+/g, ' ')
        .trim();
    },
    claseFilaProductividad(item) {
      return this.puedeDesglosarFila(item) ? 'productividad-row--clickable' : '';
    },
    onClickFilaProductividad(item) {
      if (!this.puedeDesglosarFila(item)) return;

      const index = this.filasExpandidas.indexOf(item);
      this.filasExpandidas = index === -1
        ? [...this.filasExpandidas, item]
        : this.filasExpandidas.filter(fila => fila !== item);
    },
    obtenerTurnosCrudos(item) {
      const turnos = item?.turnos || item?.Turnos || [];
      if (Array.isArray(turnos)) return turnos;
      if (turnos && typeof turnos === 'object') return [turnos];
      return [];
    },
    obtenerDetallesTurno(turno) {
      const detalle = turno?.detalle || turno?.Detalle || turno?.detalles || turno?.Detalles || [];

      if (Array.isArray(detalle)) return detalle;
      if (detalle && typeof detalle === 'object') return [detalle];
      return [];
    },
    obtenerAcumuladoTurnos(item) {
      const turnos = item?.turnos || item?.Turnos;
      const acumulado = turnos?.acumulado || turnos?.Acumulado;

      return acumulado && typeof acumulado === 'object' ? acumulado : {};
    },
    obtenerFilasTurnosParaSuma(item) {
      return this.obtenerTurnosCrudos(item).reduce((filas, turno) => {
        const detalles = this.obtenerDetallesTurno(turno);
        return detalles.length ? [...filas, ...detalles] : [...filas, turno];
      }, []);
    },
    sumarCampoTurnos(item, campos) {
      const valores = this.obtenerFilasTurnosParaSuma(item)
        .map(turno => this.valorPorCampos(turno, campos))
        .filter(valor => valor !== null && valor !== undefined && valor !== '')
        .map(valor => Number(valor))
        .filter(valor => Number.isFinite(valor));

      if (!valores.length) return null;
      return valores.reduce((total, valor) => total + valor, 0);
    },
    valorOperadoresEsperadosFila(item) {
      const acumulado = this.obtenerAcumuladoTurnos(item);
      return this.valorPorCampos(acumulado, ['operadoresEsperados', 'OperadoresEsperados']) ??
        this.valorPorCampos(item, ['operadoresEsperados', 'OperadoresEsperados']) ??
        this.sumarCampoTurnos(item, ['operadoresEsperados', 'OperadoresEsperados']);
    },
    obtenerTurnosFila(item) {
      return this.obtenerTurnosCrudos(item).reduce((filas, turno, turnoIndex) => {
        const detalles = this.obtenerDetallesTurno(turno);

        if (!detalles.length) {
          filas.push(this.normalizarTurnoDetalle(turno, item));
          return filas;
        }

        const turnoBase = { ...turno };
        delete turnoBase.detalle;
        delete turnoBase.Detalle;
        delete turnoBase.detalles;
        delete turnoBase.Detalles;

        detalles.forEach((detalleTurno, detalleIndex) => {
          filas.push(this.normalizarTurnoDetalle({
          ...turnoBase,
          ...detalleTurno,
          turno: this.valorPorCampos(detalleTurno, ['turno', 'Turno', 'nombreTurno', 'NombreTurno']) ||
            this.valorPorCampos(turnoBase, ['turno', 'Turno', 'nombreTurno', 'NombreTurno']),
          Turno: this.valorPorCampos(detalleTurno, ['turno', 'Turno', 'nombreTurno', 'NombreTurno']) ||
            this.valorPorCampos(turnoBase, ['turno', 'Turno', 'nombreTurno', 'NombreTurno']),
          _productividadDetalleKey: `${turnoIndex}-${detalleIndex}`,
          }, item));
        });

        return filas;
      }, []);
    },
    prepararFilasProductividad(filas) {
      return (Array.isArray(filas) ? filas : []).map((fila, index) => {
        const filaNormalizada = this.normalizarFilaPrincipal(fila);

        return {
          ...filaNormalizada,
          _productividadKey: [
            index,
            this.valorPorCampos(filaNormalizada, ['periodo', 'Periodo']),
            this.valorPorCampos(filaNormalizada, ['clave', 'Clave']),
            this.valorPorCampos(filaNormalizada, ['maquina', 'Maquina']),
          ].filter(valor => valor !== null && valor !== undefined && valor !== '').join('|') || String(index),
        };
      });
    },
    normalizarFilaPrincipal(fila) {
      const acumulado = this.obtenerAcumuladoTurnos(fila);
      const operadoresEsperadosAgrupados = this.sumarCampoTurnos(fila, ['operadoresEsperados', 'OperadoresEsperados']);
      const operadoresRealesAgrupados = this.sumarCampoTurnos(fila, ['operadoresReales', 'OperadoresReales']);
      const tieneAcumulado = Object.keys(acumulado).length > 0;

      if (!tieneAcumulado && operadoresEsperadosAgrupados === null && operadoresRealesAgrupados === null) return fila;

      return {
        ...fila,
        turno: this.valorAcumuladoOFila(fila, acumulado, ['turnos', 'Turnos', 'turno', 'Turno'], ['turno', 'Turno']),
        operadoresEsperados: this.valorAcumuladoOFila(fila, acumulado, ['operadoresEsperados', 'OperadoresEsperados']) ?? operadoresEsperadosAgrupados,
        operadoresReales: operadoresRealesAgrupados ?? this.valorAcumuladoOFila(fila, acumulado, ['operadoresReales', 'OperadoresReales']),
        cantidadPlaneadaOdt: this.valorAcumuladoOFila(fila, acumulado, ['cantidadPlaneadaOdt', 'CantidadPlaneadaOdt']),
        piezasEsperadasTiempoTrabajado: this.valorAcumuladoOFila(fila, acumulado, ['piezasEsperadasTiempoTrabajado', 'PiezasEsperadasTiempoTrabajado']),
        cantidadOk: this.valorAcumuladoOFila(fila, acumulado, ['cantidadOk', 'CantidadOk']),
        cantidadScrap: this.valorAcumuladoOFila(fila, acumulado, ['cantidadScrap', 'CantidadScrap']),
        cantidadTotal: this.valorAcumuladoOFila(fila, acumulado, ['cantidadTotal', 'CantidadTotal']),
        tcOperadorSegundos: this.valorAcumuladoOFila(fila, acumulado, ['tcOperadorSegundos', 'TcOperadorSegundos']),
        tiempoTrabajadoSegundos: this.valorTiempoTrabajadoReal(acumulado) ?? this.valorTiempoTrabajadoReal(fila),
        tiempoTrabajadoRealSegundos: this.valorTiempoTrabajadoReal(acumulado) ?? this.valorTiempoTrabajadoReal(fila),
        disponibilidad: this.valorAcumuladoOFila(fila, acumulado, ['disponibilidad', 'Disponibilidad']),
        productividad: this.valorAcumuladoOFila(fila, acumulado, ['productividad', 'Productividad']),
        calidad: this.valorAcumuladoOFila(fila, acumulado, ['calidad', 'Calidad']),
        ope: this.valorAcumuladoOFila(fila, acumulado, ['ope', 'Ope', 'OPE']),
      };
    },
    valorAcumuladoOFila(fila, acumulado, camposAcumulado, camposFila = camposAcumulado) {
      const valorAcumulado = this.valorPorCampos(acumulado, camposAcumulado);
      return valorAcumulado ?? this.valorPorCampos(fila, camposFila);
    },
    normalizarTurnoDetalle(turno, filaPadre) {
      return {
        ...turno,
        periodo: this.valorPorCampos(turno, ['periodo', 'Periodo']) || this.periodoTurnoDetalle(turno) || this.valorPorCampos(filaPadre, ['periodo', 'Periodo']),
        clave: this.valorPorCampos(turno, ['clave', 'Clave']) || this.valorPorCampos(filaPadre, ['clave', 'Clave']),
        maquina: this.valorPorCampos(turno, ['maquina', 'Maquina', 'maquinas', 'Maquinas']) || this.valorPorCampos(filaPadre, ['maquina', 'Maquina']),
        turno: this.valorPorCampos(turno, ['turno', 'Turno', 'nombreTurno', 'NombreTurno']),
        operadoresEsperados: this.valorPorCampos(turno, ['operadoresEsperados', 'OperadoresEsperados']) || this.valorPorCampos(filaPadre, ['operadoresEsperados', 'OperadoresEsperados']),
        operadoresReales: this.valorPorCampos(turno, ['operadoresReales', 'OperadoresReales']),
        area: this.valorPorCampos(turno, ['area', 'Area', 'areas', 'Areas']) || this.valorPorCampos(filaPadre, ['area', 'Area']),
        cantidadPlaneadaOdt: this.valorPorCampos(turno, ['cantidadPlaneadaOdt', 'CantidadPlaneadaOdt']),
        piezasEsperadasTiempoTrabajado: this.valorPorCampos(turno, ['piezasEsperadasTiempoTrabajado', 'PiezasEsperadasTiempoTrabajado']),
        cantidadOk: this.valorPorCampos(turno, ['cantidadOk', 'CantidadOk']),
        cantidadScrap: this.valorPorCampos(turno, ['cantidadScrap', 'CantidadScrap']),
        cantidadTotal: this.valorPorCampos(turno, ['cantidadTotal', 'CantidadTotal']),
        tcOperadorSegundos: this.valorPorCampos(turno, ['tcOperadorSegundos', 'TcOperadorSegundos']) || this.valorPorCampos(filaPadre, ['tcOperadorSegundos', 'TcOperadorSegundos']),
        tiempoTrabajadoSegundos: this.valorTiempoTrabajadoReal(turno),
        tiempoTrabajadoRealSegundos: this.valorTiempoTrabajadoReal(turno),
        disponibilidad: this.valorPorCampos(turno, ['disponibilidad', 'Disponibilidad']),
        productividad: this.valorPorCampos(turno, ['productividad', 'Productividad']),
        calidad: this.valorPorCampos(turno, ['calidad', 'Calidad']),
        ope: this.valorPorCampos(turno, ['ope', 'Ope', 'OPE']),
      };
    },
    periodoTurnoDetalle(turno) {
      const inicio = this.valorPorCampos(turno, ['inicio', 'Inicio']);
      const fin = this.valorPorCampos(turno, ['fin', 'Fin']);
      const inicioMoment = inicio ? moment(inicio) : null;
      const finMoment = fin ? moment(fin) : null;

      if (inicioMoment && inicioMoment.isValid() && finMoment && finMoment.isValid()) {
        return `${inicioMoment.format('HH:mm')} - ${finMoment.format('HH:mm')}`;
      }

      return inicioMoment && inicioMoment.isValid() ? inicioMoment.format('HH:mm') : '';
    },
    getOpeTiempoReal() {
      axios
        .get('/OPE/TiempoReal')
        .then(res => {
          console.log('OPE/TiempoReal:', res.data);
        })
        .catch(err => {
          console.error('Error al consultar OPE/TiempoReal:', err);
        });
    },
    nombreMaquina(maquina) {
      if (!maquina) return '';
      const nombre = maquina.nombre || maquina.Nombre || '';
      const marca = maquina.marca || maquina.Marca || '';
      const modelo = maquina.modelo || maquina.Modelo || '';

      return `[${nombre}] - ${marca} ${modelo}`.trim();
    },
    nombrePersona(persona) {
      if (!persona) return '';
      const { nombre, paterno, materno } = persona;

      return `${nombre ? `${nombre} ` : ''}${paterno ? `${paterno} ` : ''}${materno ? `${materno} ` : ''}`.trim();
    },
    parsePorcentaje(valor) {
      if (valor === null || valor === undefined || valor === '') return null;
      const numero = Number(String(valor).replace('%', '').trim());
      return Number.isFinite(numero) ? numero : null;
    },
    promedioCampo(campos) {
      const valores = this.tablaProductividad
        .map(item => this.parsePorcentaje(this.valorPorCampos(item, campos)))
        .filter(valor => valor !== null);

      if (!valores.length) return '0%';

      const promedio = valores.reduce((total, valor) => total + valor, 0) / valores.length;
      return `${promedio.toFixed(2)}%`;
    },
    valorPorCampos(item, campos) {
      const listaCampos = Array.isArray(campos) ? campos : [campos];
      const campo = listaCampos.find(nombre => item[nombre] !== null && item[nombre] !== undefined && item[nombre] !== '');
      return campo ? item[campo] : null;
    },
    valorTiempoTrabajadoReal(item) {
      return this.valorPorCampos(item, [
        'tiempoTrabajadoRealSegundos',
        'TiempoTrabajadoRealSegundos',
        'tiempoTrabajadoSegundos',
        'TiempoTrabajadoSegundos',
      ]);
    },
    valorOpeOrden(item) {
      const acumulado = this.obtenerAcumuladoTurnos(item);
      const valor = this.parsePorcentaje(
        this.valorPorCampos(acumulado, ['ope', 'Ope', 'OPE']) ??
        this.valorPorCampos(item, ['ope', 'Ope', 'OPE'])
      );
      return valor === null ? Number.POSITIVE_INFINITY : valor;
    },
    ordenarFilasPorOpe(filas) {
      return [...(Array.isArray(filas) ? filas : [])].sort((a, b) => this.valorOpeOrden(a) - this.valorOpeOrden(b));
    },
    filtrarFilasConOpe(filas) {
      return (Array.isArray(filas) ? filas : []).filter(item => {
        const operadoresEsperados = this.valorOperadoresEsperadosFila(item);
        const operadoresEsperadosNumero = operadoresEsperados === null || operadoresEsperados === undefined || operadoresEsperados === ''
          ? null
          : Number(operadoresEsperados);

        return this.valorOpeOrden(item) > 0 && operadoresEsperadosNumero !== 0;
      });
    },
    formatearPorcentaje(valor) {
      const numero = this.parsePorcentaje(valor);
      if (numero === null) return '';
      return `${numero.toFixed(2)}%`;
    },
    formatearSegundosAHoras(valor) {
      const segundos = Number(valor);
      if (!Number.isFinite(segundos)) return '';

      const totalSegundos = Math.max(0, Math.floor(segundos));
      const horas = Math.floor(totalSegundos / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      const segundosRestantes = totalSegundos % 60;

      return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(segundosRestantes).padStart(2, '0')}`;
    },
    parseFechaFiltro(fecha) {
      return moment(String(fecha || '').trim(), 'YYYY-MM-DD', true);
    },
    formatoFechaFiltro(fecha) {
      const fechaFiltro = this.parseFechaFiltro(fecha);
      return fechaFiltro.isValid() ? fechaFiltro.format('YYYY-MM-DD') : '';
    },
    consultarReporte() {
      this.errorReporte = false;
      this.errores = [];
      this.filasExpandidas = [];
      this.loadingReporte = true;

      const params = this.crearParamsReporteOpe();

      axios
        .get('/OPE/ReporteOpePersonal', { params })
        .then(response => {
          const resumen = this.obtenerResumenReporte(response.data);
          const filas = this.obtenerFilasReporte(response.data);

          this.resumenProductividad = resumen;
          this.tablaProductividad = this.prepararFilasProductividad(this.ordenarFilasPorOpe(this.filtrarFilasConOpe(filas)));
          this.loadingReporte = false;
        })
        .catch(error => {
          console.error('Error al consultar reporte OPE:', error);
          this.loadingReporte = false;
          this.errorReporte = true;
          this.tablaProductividad = [];
          this.resumenProductividad = {};
          this.errores = ['Error al obtener los datos. Por favor, intente nuevamente.'];

          if (error.response && error.response.status === 404) {
            this.errores = ['No se encontraron datos para el periodo seleccionado.'];
          }

          this.$toast?.error?.(this.errores[0]);
        });
    },
    descargarExcel() {
      this.loadingExcel = true;

      const params = this.crearParamsReporteOpe();

      axios
        .get(`/OPE/ReporteOpePersonalExcel?${params.toString()}`, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob(
            [response.data],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          );
          const link = document.createElement('a');
          const blobURL = URL.createObjectURL(blob);

          link.download = `reporte-ope-personal-${moment().format('YYYYMMDDHHmmss')}.xlsx`;
          link.href = blobURL;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobURL);
        })
        .catch(error => {
          console.error('Error al descargar reporte OPE:', error);
          this.$toast?.error?.('No se pudo descargar el reporte OPE');
        })
        .finally(() => {
          this.loadingExcel = false;
        });
    },
    crearParamsReporteOpe() {
      const params = new URLSearchParams();

      params.append('fechaInicio', this.formatoFechaFiltro(this.filtros.Desde));
      params.append('fechaFin', this.formatoFechaFiltro(this.filtros.Hasta));
      params.append('agrupacion', this.filtros.agrupacion);

      this.filtros.Operadores.forEach(id => params.append('idPersona', id));
      this.filtros.Areas.forEach(id => params.append('idArea', id));
      this.filtros.Maquinas.forEach(id => params.append('idMaquinaIns', id));
      this.filtros.Turnos.forEach(id => params.append('idTurno', id));

      return params;
    },
    obtenerResumenReporte(data) {
      if (data?.data && !Array.isArray(data.data)) return data.data;
      if (data?.result && !Array.isArray(data.result)) return data.result;
      return data || {};
    },
    obtenerFilasReporte(data) {
      if (Array.isArray(data)) {
        return data.flatMap(item => this.obtenerFilasDeGrupo(item));
      }

      if (Array.isArray(data?.registros)) return this.obtenerFilasReporte(data.registros);
      if (Array.isArray(data?.Registros)) return this.obtenerFilasReporte(data.Registros);
      if (Array.isArray(data?.data?.registros)) return this.obtenerFilasReporte(data.data.registros);
      if (Array.isArray(data?.data?.Registros)) return this.obtenerFilasReporte(data.data.Registros);
      if (Array.isArray(data?.result?.registros)) return this.obtenerFilasReporte(data.result.registros);
      if (Array.isArray(data?.result?.Registros)) return this.obtenerFilasReporte(data.result.Registros);
      if (Array.isArray(data?.detalles)) return this.obtenerFilasDeGrupo(data);
      if (Array.isArray(data?.data?.detalles)) return this.obtenerFilasDeGrupo(data.data);
      if (Array.isArray(data?.data)) return this.obtenerFilasReporte(data.data);
      if (Array.isArray(data?.result)) return this.obtenerFilasReporte(data.result);

      return [];
    },
    obtenerFilasDeGrupo(grupo) {
      if (!Array.isArray(grupo?.detalles)) return [grupo];

      const { detalles, ...datosGrupo } = grupo;
      return [{
        ...datosGrupo,
        operadoresEsperados: this.valorPorCampos(grupo, ['operadoresEsperados', 'OperadoresEsperados']) || this.operadoresEsperadosDesdeDetalles(detalles),
        operadoresReales: this.valorPorCampos(grupo, ['operadoresReales', 'OperadoresReales']) || '',
        tcOperadorSegundos: this.valorPorCampos(grupo, ['tcOperadorSegundos', 'TcOperadorSegundos']) || this.valorPrimerDetalle(detalles, ['tcOperadorSegundos', 'TcOperadorSegundos']),
      }];
    },
    operadoresEsperadosDesdeDetalles(detalles) {
      return this.valorPrimerDetalle(detalles, ['operadoresEsperados', 'OperadoresEsperados']) || '';
    },
    valorPrimerDetalle(detalles, campos) {
      const primero = Array.isArray(detalles) ? detalles[0] : null;
      return this.valorPorCampos(primero || {}, campos);
    },
    valoresUnicosDetalles(detalles, campos) {
      const valores = detalles
        .map(detalle => this.valorPorCampos(detalle, campos))
        .filter(valor => valor !== null && valor !== undefined && valor !== '');

      return [...new Set(valores)].join(', ');
    },
    onTipoAgrupacionChange() {
      this.filtros.Desde = null;
      this.filtros.Hasta = null;
      this.filtros.semanasSeleccionadas = [];
      this.semanas = [];
      this.filasExpandidas = [];
    },
    onAplicar(weeks) {
      const lista = weeks || this.semanas || [];
      this.setRangeFromWeeks(lista);
      this.filtros.semanasSeleccionadas = lista.map(w => ({
        year: w.isoYear,
        week: w.isoWeek,
        desde: w.start,
        hasta: w.end,
        etiqueta: `Sem. ${String(w.isoWeek).padStart(2, '0')} '${String(w.isoYear).slice(-2)}`,
      }));
    },
    setRangeFromWeeks(weeks) {
      if (!weeks || !weeks.length) {
        this.filtros.Desde = null;
        this.filtros.Hasta = null;
        return;
      }

      const starts = weeks.map(w => w.start).sort();
      const ends = weeks.map(w => w.end).sort();
      this.filtros.Desde = starts[0];
      this.filtros.Hasta = ends[ends.length - 1];
    },
    getMaquinas() {
      this.loadingMaquinas = true;
      axios
        .get('/MaquinaInstancias')
        .then(res => {
          this.maquinas = Array.isArray(res.data) ? res.data : [];
          //console.log("hola");
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingMaquinas = false;
        });
    },
    getAreas() {
      this.loadingAreas = true;
      axios
        .get('/Areas')
        .then(res => {
          this.areas = Array.isArray(res.data)
            ? res.data.filter(area => area.idArea > 1)
            : [];
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingAreas = false;
        });
    },
    getTurnos() {
      this.loadingTurnos = true;
      axios
        .get('/Turnos')
        .then(res => {
          this.turnos = Array.isArray(res.data) ? res.data : [];
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingTurnos = false;
        });
    },
    getOperadores() {
      this.loadingOperadores = true;
      axios
        .get('/Personas/Operadores')
        .then(res => {
          this.operadores = Array.isArray(res.data) ? res.data : [];
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingOperadores = false;
        });
    },
  },
};
</script>

<style scoped>
.productividad-week-picker {
  width: 100%;
}

::v-deep .productividad-row--clickable {
  cursor: pointer;
}

::v-deep .productividad-row--clickable:hover {
  background: #f6f9fc;
}

::v-deep .productividad-turno-header,
.productividad-turno-cell {
  white-space: nowrap;
}

.productividad-tiempo-header {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  white-space: nowrap;
}

.productividad-detalle-cell {
  background: #f8fafc;
}

.productividad-detalle-table {
  margin: 8px 12px 12px;
  border: 1px solid #e6e8ee;
  border-radius: 8px;
  overflow: hidden;
}

.productividad-kpi-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-top: 16px;
}

.productividad-kpi-card {
  border: 1px solid #e6e8ee;
  border-radius: 8px;
  background: #ffffff;
  padding: 14px 16px;
  min-height: 112px;
}

.productividad-kpi-card--blue {
  border-left: 4px solid #2a6099;
}

.productividad-kpi-card--green {
  border-left: 4px solid #2f855a;
}

.productividad-kpi-card--amber {
  border-left: 4px solid #b7791f;
}

.productividad-kpi-card--violet {
  border-left: 4px solid #6b46c1;
}

.productividad-kpi-top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.productividad-kpi-icon-pack {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.productividad-kpi-icon-pack--blue {
  background: #e8f1fb;
}

.productividad-kpi-icon-pack--green {
  background: #e7f6ee;
}

.productividad-kpi-icon-pack--amber {
  background: #fff4dc;
}

.productividad-kpi-icon-pack--violet {
  background: #f1ecff;
}

.productividad-kpi-icon {
  font-size: 20px;
}

.productividad-kpi-icon-pack--blue .productividad-kpi-icon {
  color: #2a6099;
}

.productividad-kpi-icon-pack--green .productividad-kpi-icon {
  color: #2f855a;
}

.productividad-kpi-icon-pack--amber .productividad-kpi-icon {
  color: #b7791f;
}

.productividad-kpi-icon-pack--violet .productividad-kpi-icon {
  color: #6b46c1;
}

.productividad-kpi-title {
  color: #5f6875;
  font-size: 13px;
  font-weight: 700;
  margin: 0;
  text-transform: uppercase;
}

.productividad-kpi-value {
  color: #1f2937;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.1;
  margin: 12px 0 0;
}

.productividad-kpi-caption {
  color: #748093;
  font-size: 13px;
  margin: 6px 0 0;
}

@media (max-width: 960px) {
  .productividad-kpi-grid {
    grid-template-columns: 1fr;
  }
}
</style>